<script setup lang="ts">
import { timeoutDelay } from '@/helpers/utils/timeoutDelay'
import LineItemReviewBlock from '@/components/projects/branding/line-item-review/LineItemReviewBlock.vue'

interface IProps {
  modelValue: boolean,
  projectId?: string | number,
  workOrderId?: string | number,
  lineItemId?: string | number,
}

const props = withDefaults(defineProps<IProps>(), {
  modelValue: false,
  projectId: '',
  workOrderId: '',
  lineItemId: '',
})
interface Emit {
  (e: 'update:modelValue', value: boolean): void
  (e: 'onClose'): void
  (e: 'onApprovalAction'): void
}

const emit = defineEmits<Emit>()

const loading = ref<boolean>(false)

const hasApprovalAction = ref<boolean>(false)

const lineItemReviewBlockRef = ref<InstanceType<typeof LineItemReviewBlock> | null>()

const closeDialog = () => {
  emit('update:modelValue', false)
}

const onClose = async () => {
  if (hasApprovalAction.value) {
    emit('onApprovalAction')
    hasApprovalAction.value = false // Reset for next time
  }
  emit('onClose')
}

watch(() => props.modelValue, async () => {
  // On show dialog
  if (props.modelValue) {
    await timeoutDelay(0)
    lineItemReviewBlockRef.value?.initReviewBlock()
  }
  // On hide dialog
  else {
    await onClose()
  }
})
</script>

<template>
  <div>
    <VDialog
      :model-value="modelValue"
      fullscreen
      class="default-dialog line-item-review-dialog"
      @after-leave="onClose"
      @update:modelValue="emit('update:modelValue')"
    >
      <VBtn
        variant="elevated"
        density="compact"
        icon="tabler-x"
        :disabled="!!loading"
        class="v-dialog-close-btn mt-2 mr-3"
        @click="closeDialog"
      />

      <VCard>
        <template #title>
          Line Item
        </template>
        <LineItemReviewBlock
          ref="lineItemReviewBlockRef"
          :project-id="projectId"
          :work-order-id="workOrderId"
          :line-item-id="lineItemId"
          :is-review-dialog="true"
          @onApprovalAction="hasApprovalAction = true"
        />
      </VCard>
    </VDialog>
  </div>
</template>

<style lang="scss">

</style>
